module.exports = __webpack_public_path__ + "984e686f5776fe880be439d150b92cea.pdf";